import { LS_LAST_MESSAGE_SENT_AT } from '../../common/constants/private';

export const setLastMessageSentAt = (timestamp: number | null): void => {
	if (timestamp === null) {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.removeItem(LS_LAST_MESSAGE_SENT_AT);
		return;
	}

	// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
	localStorage.setItem(LS_LAST_MESSAGE_SENT_AT, timestamp.toString());
};
